import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchPractitioners = async ({ clinicId }) => {
  const token = localStorage.getItem("token");

  const url = clinicId
    ? `${__API_URL__}/api/appointments/all_practitioners?clinic=${clinicId}`
    : `${__API_URL__}/api/appointments/all_practitioners`;

  const response = await axios.get(url, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetPractitioners = ({ clinicId, enabled = true } = {}) => {
  return useQuery({
    queryKey: ["practitioners", clinicId],
    queryFn: () => fetchPractitioners({ clinicId }),
    enabled,
  });
};

export default useGetPractitioners;
